import React from 'react';
import { FontSizeProps, MarginProps, SizeProps } from 'styled-system';

import * as Colors from '../constants/Colors';
import profile from '../images/profile.svg';
import { FlexBox } from '../layout/FlexBox';
import { Image } from '../misc/Image';
import { InlineText } from '../typography/InlineText';
import { ColorProps } from '../utils/styled-components/styledSystem';

export type AvatarProps = ColorProps &
    MarginProps &
    SizeProps &
    FontSizeProps & {
        profile: {
            firstName: string;
            lastName: string;
            profilePicture?: string | null;
        };
        className?: string;
    };

export function Avatar(props: AvatarProps) {
    const errorHandler = (event: React.SyntheticEvent<HTMLImageElement>) => {
        event.currentTarget.onerror = null;
        event.currentTarget.src = profile;
    };

    const getInitials = (firstName: string, lastName: string) => {
        const firstNameInitial = firstName.slice(0, 1).toUpperCase();
        const lastNameInitial = lastName.slice(0, 1).toUpperCase();
        return firstNameInitial + lastNameInitial;
    };

    if (props.profile.profilePicture == null || props.profile.profilePicture.length === 0) {
        return (
            <FlexBox
                size={props.size}
                minWidth={props.size}
                margin={props.margin}
                backgroundColor={props.backgroundColor}
                justifyContent="center"
                alignItems="center"
                borderRadius="50%"
                className={props.className}
            >
                <InlineText fontSize={props.fontSize} fontWeight="600" textColor={props.textColor}>
                    {getInitials(props.profile.firstName, props.profile.lastName)}
                </InlineText>
            </FlexBox>
        );
    }

    return (
        <Image
            src={props.profile.profilePicture ? props.profile.profilePicture : profile}
            alt={`expert ${props.profile.firstName} ${props.profile.lastName}`}
            onError={errorHandler}
            size={props.size}
            minWidth={props.size}
            margin={props.margin}
            borderRadius="50%"
            objectFit="cover"
            objectPosition="top"
            className={props.className}
        />
    );
}

Avatar.defaultProps = {
    size: '40px',
    margin: '0',
    fontSize: '18px',
    backgroundColor: Colors.blue,
    textColor: Colors.white,
};
